import { CompanyShort } from '../company/types'
import { DealShipment } from '../deal/types'
import { Address } from '../types'
import { User } from '../user/types'

export enum WarehousesCondition {
  opened = 'opened',
  closed = 'closed',
}

export enum WarehouseStatuses {
  active = 'active',
  archived = 'archived',
}

export const MovementsTabTypes = {
  grouped: 'grouped',
  ungrouped: 'ungrouped',
}

export enum MovementType {
  income = 'income',
  outcome = 'outcome',
}

type ProductRemaining = {
  product_title: string
  total_quantity: string
}

export type Warehouse = {
  id: string
  title: string
  address: Address
  owner: User
  status: WarehouseStatuses
  total_quantity: string
  products_remaining: ProductRemaining[]
}

export type ElevatorCosts = {
  id: number
  acceptance_costs: number | null
  storage_costs: number | null
  storage_costs_unit: string
  mechanical_railcar_loading_costs: number | null
  expedite_costs: number | null
  documents_costs: number | null
  other_costs: number | null
  is_composite_costs: boolean
  composite_costs: number | null
  comment: string
}

export type Elevator = {
  id: string
  title: string
  address: Address
  company: CompanyShort
  railway_station?: {
    id: number
    station_code: string
    title: string
  }
  provided_services?: string
  capacity?: number
  rail_car_capacity?: number
  elevator_costs: ElevatorCosts[]
  created: string
  modified: string
}

type WarehouseProduct = {
  id: number
  slug: string
  title: string
}

type WarehouseDealShort = {
  id: number
  quantity: number
  price_exw: number
  price_cpt: number
  sale_price: number
  purchase_price: number
  price_logistics: number
  price_carrier: number
  product: WarehouseProduct
}

type WarehouseShort = {
  id: number
  address: Address
  owner: User
  title: string
}

export type WarehouseMovement = {
  id: number
  warehouse: WarehouseShort
  deal: WarehouseDealShort
  movement_type: MovementType
  storage_price: number | null
  handling_price: number | null
  transshipment_price: number | null
  product_title: string
  seller: User
  seller_address_title: string
  customer: User
  customer_address_title: string
  documents_request_expected_complete_date: string | null
  quantity: number
  price_exw: number
  shipments: DealShipment[]
  sale_bid_id: number
}

export type WarehouseMovementGrouped = {
  id: number
  sale_bid_id: number
  warehouse: WarehouseShort
  movement_type: MovementType
  storage_price: number | null
  handling_price: number | null
  transshipment_price: number | null
  product_title: string
  seller: User
  seller_address_title: string
  customer: User
  customer_address_title: string
  documents_request_expected_complete_date: string | null
  remaining_quantity: number
  price_exw: number
}
